module.exports = __webpack_public_path__ + "static/media/micro.37d4c8b3.png";